import { useEffect, useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Typography,
  Button,
  IconButton,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { TabContext, TabPanel } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";
import { EditTemplateList } from "../../Services/TemplateApi";
import { toast, ToastContainer } from "react-toastify";
import { ReactComponent as PhoneIphoneIcon } from "../../Assets/mobile.svg";
import { ReactComponent as TabletMacIcon } from "../../Assets/tablet.svg";

import { ReactComponent as LaptopMacIcon } from "../../Assets/desktop.svg";
import { ReactComponent as RefreshIcon } from "../../Assets/refresh.svg";
import { Editor } from "@monaco-editor/react";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as ModalTitleIcon } from "../../Assets/modaltitle.svg";
import { ReactComponent as SettingIcon } from "../../Assets/setting.svg";
import { ReactComponent as CodeIcon } from "../../Assets/code.svg";
import { ReactComponent as CodeViewIcon } from "../../Assets/codeView.svg";
import { ReactComponent as ArrowBackIcon } from "../../Assets/backarrow.svg";
import Tooltip from "@mui/material/Tooltip";
const EditTemplate = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("html");
  type ViewMode = "mobile" | "tablet" | "desktop";
  const template = location.state?.template;
  const [viewMode, setViewMode] = useState<ViewMode>("desktop");
  const [previousViewMode, setPreviousViewMode] = useState<any>(null);
  const [scriptContent, setScriptContent] = useState("");
  const [errors, setErrors] = useState({ title: false, useCase: false });
  const [open, setOpen] = useState(true);
  const [initialTemplateData] = useState({
    title: template.title,
    useCase: template.usecase,
    description: template.description,
    html: template.html,
    css: template.css,
  });
  const [formData, setFormData] = useState({
    title: template.title,
    useCase: template.usecase,
    description: template.description,
    html: template.html,
    css: template.css,
  });

  const isDirty =
    JSON.stringify(formData) !== JSON.stringify(initialTemplateData);
  useEffect(() => {}, [formData]);
  const viewStyles: Record<ViewMode, { width: string }> = {
    mobile: { width: "375px" }, // iPhone size
    tablet: { width: "768px" }, // Tablet size
    desktop: { width: "100%" }, // Full width for desktop
  };
  const [showCodeEditor, setShowCodeEditor] = useState(false);
  const [showPreviewEditor, setShowPreviewEditor] = useState(false);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("settings");
  const [loadingButton, setLoadingButton] = useState<
    null | "draft" | "publish"
  >(null);

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (template) {
      setFormData({
        title: template.title || "",
        useCase: template.usecase || "",
        description: template.description || "",
        html: template.html,
        css: template.css,
      });
    }
  }, [template]);
  useEffect(() => {
    if (scriptContent) {
      const script = document.createElement("script");
      script.textContent = scriptContent;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [scriptContent]);
  const updateTemplate = async (
    statusValue: number,
    type: "draft" | "publish"
  ) => {
    const newErrors = {
      title: !formData.title,
      useCase: !formData.useCase,
    };
    setErrors(newErrors);

    try {
      setLoadingButton(type);
      const response = await EditTemplateList(
        template.id,
        formData.title,
        formData.useCase,
        formData.description,
        formData.html || "",
        formData.css || "",
        statusValue
      );

      if (response.success === true) {
        toast.success(response.message);
        navigate("/templates/list");
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.error("Error updating template:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoadingButton(null);
    }
  };

  const processHtml = (htmlContent: any) => {
    if (!htmlContent || typeof htmlContent !== "string") {
      return "";
    }
    const scriptRegex = /<div custom-script>([\s\S]*?)<\/div>/g;
    let scripts = "";
    let processedHtml = htmlContent.replace(
      scriptRegex,
      (scriptContent: any) => {
        scripts += `<script>${scriptContent}</script>`;
        return "";
      }
    );

    const generateCaptcha = () => {
      const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let captcha = "";
      for (let i = 0; i < 6; i++) {
        captcha += chars[Math.floor(Math.random() * chars.length)];
      }
      return captcha;
    };
    if (processedHtml.includes('id="image-captcha"')) {
      const captchaCode = generateCaptcha();
      processedHtml = processedHtml.replace(
        '<div id="image-captcha"></div>',
        `<div id="image-captcha">${captchaCode}</div>`
      );
    }
    return processedHtml + scripts;
  };
  const onback = () => {
    navigate("/templates/list");
  };
  const handleClose = () => {
    navigate("/templates/list");
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(true)}
      fullWidth
      maxWidth="md"
      className=""
      // sx={{
      //   '& .MuiPaper-root': {
      //     height: '80vh',
      //   },
      // }}
    >
      <div className="editModal">
        <div className="editModal_header">
          <div className="editModal_header--left">
            <IconButton
              onClick={() => {
                setShowCodeEditor(false);
                setShowPreviewEditor(false);
              }}
            >
              <ArrowBackIcon onClick={() => onback()} />
            </IconButton>

            <div className="ModalTitleIcon Icon ">
              <ModalTitleIcon />
            </div>
            {/* Title */}
            <h6>{formData.title}</h6>
          </div>
          <div className="mobile_code--view">
            {/* Action Buttons */}
            <Box display={"flex"} alignItems={"center"}>
              <div
                className={`action_button ${
                  selectedTab === "settings" ? "active" : ""
                }`}
                onClick={() => {
                  setShowCodeEditor(false);
                  setShowPreviewEditor(false);
                  setSelectedTab("settings");
                }}
              >
                <IconButton>
                  <SettingIcon />
                </IconButton>
              </div>

              <div
                className={`action_button ${
                  selectedTab === "code" ? "active" : ""
                }`}
                onClick={() => {
                  setShowCodeEditor(true);
                  setShowPreviewEditor(false);
                  setSelectedTab("code");
                }}
              >
                <IconButton>
                  <CodeIcon />
                </IconButton>
              </div>

              <div
                className={`action_button ${
                  selectedTab === "preview" ? "active" : ""
                }`}
                onClick={() => {
                  setShowPreviewEditor(true);
                  setShowCodeEditor(false);
                  setSelectedTab("preview");
                }}
              >
                <IconButton className="CodeViewIcon">
                  <CodeViewIcon />
                </IconButton>
              </div>
              <div className="action_button mobile_close--btn">
                <IconButton>
                  <CloseIcon onClick={() => handleClose()} />
                </IconButton>
              </div>
            </Box>
          </div>
        </div>

        <DialogContent dividers sx={{ marginTop: "2rem" }}>
          {!showCodeEditor && !showPreviewEditor && (
            <div className="editModal_body">
              <Grid container spacing={{ xs: 0, sm: 2, md: 2 }}>
                <Grid
                  className="editModal_form"
                  size={{ xs: 12, md: 3, sm: 3 }}
                  sx={{}}
                >
                  <Typography fontWeight="bold" color="rgba(228, 0, 43, 1)">
                    Title:
                  </Typography>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 9, sm: 9 }}
                  className="editModal_form--input"
                >
                  <TextField
                    fullWidth
                    required
                    variant="standard"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    error={errors.title}
                    helperText={errors.title ? "Title is required" : ""}
                    sx={{ textAlign: "center" }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={{ xs: 0, sm: 2, md: 2 }}>
                <Grid
                  size={{ xs: 12, md: 3, sm: 3 }}
                  className="editModal_form"
                >
                  <Typography fontWeight="bold" color="rgba(228, 0, 43, 1)">
                    Use case:
                  </Typography>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 9, sm: 9 }}
                  className="editModal_form--input"
                >
                  <TextField
                    select
                    fullWidth
                    required
                    variant="standard"
                    name="useCase"
                    value={formData.useCase}
                    onChange={handleChange}
                    error={errors.useCase}
                    helperText={errors.useCase ? "Use case is required" : ""}
                  >
                    {["metering", "lightbox"].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option.charAt(0).toUpperCase() + option.slice(1)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <Grid container spacing={{ xs: 0, sm: 2, md: 2 }}>
                <Grid
                  size={{ xs: 12, md: 3, sm: 3 }}
                  className="editModal_form"
                >
                  <Typography fontWeight="bold" color="rgba(228, 0, 43, 1)">
                    Description:
                  </Typography>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 9, sm: 9 }}
                  className="editModal_form--input"
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={3}
                    name="description"
                    placeholder="Enter Description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </div>
          )}

          {showCodeEditor && (
            <div className="edit_tabination">
              <TabContext value={activeTab}>
                <Tabs
                  value={activeTab}
                  onChange={(event, newValue) => setActiveTab(newValue)}
                >
                  <Tab label="HTML" value="html" />
                  <Tab label="CSS" value="css" />
                </Tabs>
                <TabPanel
                  sx={{
                    padding: "10px 0px",
                  }}
                  value="html"
                >
                  <Editor
                    height="50vh"
                    defaultLanguage="html"
                    value={formData.html}
                    theme="default"
                    onChange={(newValue) =>
                      setFormData((prev) => ({ ...prev, html: newValue || "" }))
                    }
                    options={{
                      minimap: {
                        enabled: false,
                      },
                    }}
                  />
                </TabPanel>
                <TabPanel
                  sx={{
                    padding: "10px 0px",
                  }}
                  value="css"
                >
                  <Editor
                    height="50vh"
                    defaultLanguage="css"
                    value={formData.css}
                    theme="default"
                    onChange={(newValue) =>
                      setFormData((prev) => ({ ...prev, css: newValue || "" }))
                    }
                    options={{
                      minimap: {
                        enabled: false,
                      },
                    }}
                  />
                </TabPanel>
              </TabContext>
            </div>
          )}

          {showPreviewEditor && (
            <div  >
              <Box display="flex" justifyContent="center" mb={2}>
                <div
                  className={`code_view ${
                    viewMode === "desktop" ? "active" : ""
                  }`}
                  onClick={() => {
                    setPreviousViewMode(viewMode);
                    setViewMode("desktop")}}
                >
                  <Tooltip title="Desktop View" arrow placement="top">
                    <IconButton>
                      <LaptopMacIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                <div
                  className={`code_view ${
                    viewMode === "tablet" ? "active" : ""
                  }`}
                  onClick={() => {
                    setPreviousViewMode(viewMode);
                    setViewMode("tablet");
                  }}
                >
                  {" "}
                  <Tooltip title="Tablet View" arrow placement="top">
                    <IconButton>
                      <TabletMacIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                <div
                  className={`code_view ${
                    viewMode === "mobile" ? "active" : ""
                  }`}
                  onClick={() => {
                    setPreviousViewMode(viewMode);
                    setViewMode("mobile")}}
                >
                  <Tooltip title="Mobile View" arrow placement="top">
                    <IconButton>
                      <PhoneIphoneIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                <div
                  className="code_view"
                  onClick={() => {
                    if (previousViewMode) {
                      setViewMode(previousViewMode);
                    }
                  }}
                >
                  <Tooltip title="Refresh" arrow placement="top">
                    <IconButton >
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </Box>

              <Box
                sx={{
                  height: "60vh",
                  overflow: "auto",
                }}
              >
                <style>
                  {`
                  .ng-hide {
                    display: none !important;
                  }
                `}
                </style>
                <style>{formData.css}</style>
                <Box
                 className="tn-lightbox"
                  sx={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                    border: "1px solid #ccc",
                    background: "rgba(228, 0, 43, 1)",
                    ...viewStyles[viewMode],
                  }}
                  dangerouslySetInnerHTML={{
                    __html: processHtml(formData.html),
                  }}
                />
              </Box>
            </div>
          )}
        </DialogContent>

        <DialogActions disableSpacing className="modal_footer--button">
       
              {isDirty && (
                <span className="mx-12">You have unsaved changes</span>
              )}
              <Button
                variant="outlined"
                color="primary"
                disabled={
                  !isDirty ||
                  loadingButton === "draft" ||
                  loadingButton === "publish"
                }
                onClick={() => updateTemplate(0, "draft")}
                sx={{
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",

                  "&:hover": {
                    "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                    "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                    "--variant-containedBg": "rgba(228, 0, 43, 1)",
                    "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                  },
                }}
              >
                {loadingButton === "draft" ? (
                  <span className="loader" />
                ) : (
                  "Save as Draft"
                )}
              </Button>

              <Button
               
                variant="contained"
                color="success"
                disabled={
                  !isDirty ||
                  loadingButton === "publish" ||
                  loadingButton === "draft"
                }
                onClick={() => updateTemplate(1, "publish")}
                sx={{
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                }}
              >
                {loadingButton === "publish" ? (
                  <span className="loader" />
                ) : (
                  "Publish"
                )}
              </Button>
         
        </DialogActions>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </Dialog>
  );
};

export default EditTemplate;
